import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const ReEnrollmentsRedux = createActions(
  {
    updateDataAfterInscription: ['data'],
  },
  {
    prefix: 'RE_ENROLLMENTS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ReEnrollmentsRedux
export const ReEnrollmentsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

const updateDataAfterInscription = (state, { data }) => {
  const newInscriptions = R.clone(state.get.results)
  const [student] = newInscriptions.filter(child => child.id === data.id)
  const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(newInscriptions)
  newInscriptions.splice(activeStudentIndex, 1)
  return state.merge({ get: { fetching: false, results: newInscriptions } }, d)
}


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.updateDataAfterInscription]: updateDataAfterInscription,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReEnrollmentsRedux.js